import React from "react";
import ImageUploader from "storybookComponents/ImageUploader";
import environment from "environments/environment"
import UserContext from 'context/UserContext';

const tabs = [
  {
    long_text: "Upload",
    short_text: "Upload"
  },
  {
    long_text: "Property Images",
    short_text: "Property"
  },
  {
    long_text: "Org Images",
    short_text: "Org"
  },
  {
    long_text: "Floor Plan",
    short_text: "Floor"
  }
];


const ImageChanger = ({ onChange, customButton, showNotification, onRef, assetCategory, ...rest }) => {
  const { subOrgDetails } = React.useContext(UserContext);
  return (
    <ImageUploader
      ref={onRef}
      categoryId={assetCategory}
      propertyId={subOrgDetails.id}
      environment={environment}
      handleNotification={(e) => showNotification(e, "error")}
      customButton={customButton}
      fieldField={1}
      tabs={tabs}
      onUploadFinish={onChange}
      {...rest}
    />
  )
}


export default React.memo(ImageChanger);